export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const ENCRYPTION_IV = process.env.NEXT_PUBLIC_ENCODED_STRING;
export const ENCRYPTION_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;
export const STRAPI_BASE_URL = process.env.NEXT_PUBLIC_STRAPI_BASE_URL;
export const STRAPI_PROXY = process.env.NEXT_PUBLIC_STRAPI_PROXY;
export const VPL_ENCRYPTION_KEY = process.env.NEXT_PUBLIC_VPL_ENCRYPTION_KEY;
export const VPL_ENCODED_IV = process.env.NEXT_PUBLIC_VPL_ENCODED_IV;
